export enum AnnouncementLanguage {
  Turkish = 0,
  English = 1,
}
